import { FC, useState } from 'react';
import { useSearch } from '@/hooks';
import { useSearchSitesQuery } from '@/apis/sites/sitesApi';
import { SelectV2 } from '@data-products-and-ai/react-components';
import { Option } from '@data-products-and-ai/react-components/lib/components/Forms/SelectV2/SelectV2';

import '@/pages/Outages/components/SitesFilter/SitesFilter.scss';

const SITES_LIMIT = 100;

interface SitesFilterProps {
  disabled?: boolean;
  onChange: (siteId: string) => void;
}

export const SitesFilter: FC<SitesFilterProps> = ({
  disabled = false,
  onChange,
}) => {
  const { debouncedQuery, handleSearch } = useSearch();
  const [selectedValues, setSelectedValues] = useState<Option[]>([]);
  const { data, isLoading, isFetching } = useSearchSitesQuery({
    limit: SITES_LIMIT,
    query: debouncedQuery,
  });
  const sites = (data || []) as Option[];
  const loadingState = isLoading || isFetching;

  const handleSiteChange = (values: Option | Option[]) => {
    const site = values as Option;

    setSelectedValues(site ? [site] : []);

    onChange(site?.value ?? null);
  };

  const handleSearchByText = (value: string) => {
    handleSearch(value);
  };

  return (
    <div className="sites-filter">
      <SelectV2
        isDisabled={disabled}
        menuWithCheckIcon
        options={sites}
        isClearable
        isSearchable
        noOptionsMessage={
          loadingState ? 'Searching sites...' : 'No sites found'
        }
        closeMenuOnSelect
        selectedValues={selectedValues}
        placeholder="Select site..."
        onChange={handleSiteChange}
        onInput={handleSearchByText}
      />
    </div>
  );
};
